var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-chess",attrs:{"href":_vm.link}},[_vm._v("Выбрать квартиру")])
}
var staticRenderFns = []

export { render, staticRenderFns }